module.exports = __webpack_public_path__ + "img/amazon-logo.93d60085.svg";